module.exports = __webpack_public_path__ + "images/download-packing-f69d78c70b03f1bc96cdafba1eaf71fc.gif";